class HeaderTrustBarSlider extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('.header-trust-bar__grid');
    this.interval = (Number(this.getAttribute('interval')) || 5) * 1000;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.handleVisibilityChange = () => (document.hidden ? this.pause() : this.play());
    this.handleQueryChange = () => this.play();
    this.handleInteractionStart = () => this.pause();
    this.handleInteractionEnd = () => this.play();

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.mobileQuery.addEventListener('change', this.handleQueryChange);
    this.reducedMotionQuery.addEventListener('change', this.handleQueryChange);
    this.scroller.addEventListener('pointerdown', this.handleInteractionStart);
    this.scroller.addEventListener('pointerup', this.handleInteractionEnd);
    this.scroller.addEventListener('focusin', this.handleInteractionStart);
    this.scroller.addEventListener('focusout', this.handleInteractionEnd);

    this.play();
  }

  disconnectedCallback() {
    this.pause();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.mobileQuery.removeEventListener('change', this.handleQueryChange);
    this.reducedMotionQuery.removeEventListener('change', this.handleQueryChange);
  }

  get isActive() {
    return (
      this.getAttribute('data-layout') === 'slider' &&
      this.mobileQuery.matches &&
      !this.reducedMotionQuery.matches
    );
  }

  play() {
    this.pause();
    if (!this.isActive || document.hidden) return;
    this.timer = setInterval(() => this.next(), this.interval);
  }

  pause() {
    clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    const cells = this.scroller.children;
    if (!cells.length) return;
    const step = this.scroller.clientWidth;
    const atEnd = this.scroller.scrollLeft + step >= this.scroller.scrollWidth - 1;
    this.scroller.scrollTo({
      left: atEnd ? 0 : this.scroller.scrollLeft + step,
      behavior: 'smooth',
    });
  }
}

customElements.define('header-trust-bar-slider', HeaderTrustBarSlider);
